<template>
    <v-list-item-content class="py-1" style="height: unset; max-width: 120px;">
        <!-- Template for purchase order -->
        <template v-if="!availableSums">
            <v-list-item-subtitle class="pl-2" style="font-size: 12.5px !important;">
                <v-badge :color="'yellow'" inline class="mt-0" dot></v-badge>
                {{ $t('servicesystem.common_objects.store.purchase_order') }}
            </v-list-item-subtitle>
        </template>
        <!-- Template for warehouse stocks -->
        <template v-else>
            <v-list-item-subtitle v-for="storeKey in sumkeys" :key="storeKey" class="pl-2"
                style="font-size: 12px !important;">
                <v-badge :color="availableSums[storeKey] > 0 ? 'green' : 'error'" inline class="mt-0" dot></v-badge>
                {{ formatNumber(availableSums[storeKey]) }}
                {{ sumLabels[storeKey] }}
            </v-list-item-subtitle>
        </template>

    </v-list-item-content>
</template>


<script>
export default {
    name: 'StockIndicator',
    props: {
        StoreItems: Array,
    },
    components: {},

    data() {
        return {
        };
    },

    methods: {
        formatNumber(value) {
            return parseFloat(value.toFixed(2)).toString();
        },
    },

    computed: {
        userStoreId() {
            return this.userInfo.StoreId;
        },

        mainStoreId() {
            return this.$store.state.GlobalSettings.MainStoreId;
        },

        sumLabels() {
            return {
                MyStore: this.$t('servicesystem.common_objects.store.my_store'),
                MainStore: this.$t('servicesystem.common_objects.store.main_store'),
                OtherStores: this.$t('servicesystem.common_objects.store.other_stores'),
            };
        },

        sumkeys() {
            var arr = ['MainStore', 'OtherStores'];
            if (this.userStoreId && this.userStoreId !== this.mainStoreId) {
                arr.unshift('MyStore');
            }
            return arr;
        },

        availableSums() {
            if (!this.StoreItems || !this.StoreItems.some(x => x.Available > 0)) {
                return null;
            }

            const userStoreId = this.userStoreId;
            const mainStoreId = this.mainStoreId;
            const sums = this.StoreItems.reduce((acc, item) => {
                if (item.Store_Id === userStoreId && userStoreId != mainStoreId) {
                    acc.MyStore += item.Available;
                } else if (item.Store_Id === mainStoreId) {
                    acc.MainStore += item.Available;
                } else {
                    acc.OtherStores += item.Available;
                }
                return acc;
            }, { MyStore: 0, MainStore: 0, OtherStores: 0 });
            console.log("Available sums:", sums, this.StoreItems);
            return sums;
        }
    },

    watch: {},
};
</script>


<style lang='scss'></style>